import { zChargingStationModelCommonSchema } from "./chargingStationModel.common";
import { z } from "zod";
// ChargingStationModel Domain схема (расширяет базовую схему)
export const zChargingStationModelSchemaDom = zChargingStationModelCommonSchema;
export const zChargingStationModelSchemaCreateDom = zChargingStationModelSchemaDom.omit({ id: true });
export const zChargingStationModelSearchViewSchema = zChargingStationModelSchemaDom.extend({
    manufacturerName: z.string().nullish(),
});
